import { render, staticRenderFns } from "./PersonnelRecordDetailsTabDeadlines.vue?vue&type=template&id=4e79bbf2"
import script from "./PersonnelRecordDetailsTabDeadlines.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabDeadlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports